import PropTypes from 'prop-types'
import styled from 'styled-components'

import {
  Box,
  Heading,
  Image,
  Link,
  Text,
  TransparentButton,
} from '@redriverpress/system'
import videoPropShape from '../constants/videoPropShape'
import { routes } from '../../constants'

const CardContent = styled(Box).attrs({
  borderRadius: 'small',
  color: 'black',
  p: 0,
  width: 1,
  height: '100%',
  bg: 'white',
})`
  cursor: pointer;
  &:focus {
    outline: none;
  }

  &:focus-visible {
    box-shadow: 0 0 0 2px ${props => props.theme.colors.blue500};
  }

  &:after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: ${props => props.theme.radii.rounded};
    box-shadow: ${props => props.theme.shadows[3]};
    opacity: 0;
    transition: 0.15s ease-in;
  }

  &:hover:after,
  &:focus:after {
    opacity: 1;
  }
`

// This component should render a Link or a Div according to the user access status:
// They must be logged in and have a paid subscription.
const Wrapper = ({ video, isUserAllowed, openInfoModal, children }) =>
  isUserAllowed ? (
    <Link
      position='relative'
      href={
        video.slug
          ? `${routes.video}/${video.slug}`
          : `${routes.video}/${video.id}`
      }
      reset
    >
      {children}
    </Link>
  ) : (
    <TransparentButton p={0} position='relative' onClick={openInfoModal}>
      {children}
    </TransparentButton>
  )

Wrapper.propTypes = {
  video: PropTypes.shape(videoPropShape).isRequired,
  isUserAllowed: PropTypes.bool.isRequired,
  openInfoModal: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}

export default function VideoCard({
  video,
  isUserAllowed,
  openInfoModal,
  showCategory,
}) {
  return (
    <Wrapper
      isUserAllowed={isUserAllowed}
      video={video}
      openInfoModal={openInfoModal}
    >
      <CardContent>
        <Box display='flex' flexDirection='column'>
          <Image
            src={video.image}
            alt=''
            width={1}
            height={[108, null, null, 124]}
            style={{
              objectFit: 'cover',
            }}
          />
          <Box
            py={2}
            px={3}
            display='flex'
            flexDirection='column'
            alignItems='flex-start'
          >
            <Heading as='h6' mb={0} textAlign='left'>
              {video.title}
            </Heading>
            {showCategory && video?.category?.title && (
              <Text fontSize={0}>{video?.category?.title}</Text>
            )}
            {video.subtitle && (
              <Text as='span' mt={1} fontSize={0}>
                {video.subtitle}
              </Text>
            )}
          </Box>
        </Box>
      </CardContent>
    </Wrapper>
  )
}

VideoCard.defaultProps = {
  showCategory: false,
}

VideoCard.propTypes = {
  video: PropTypes.shape(videoPropShape).isRequired,
  isUserAllowed: PropTypes.bool.isRequired,
  openInfoModal: PropTypes.func.isRequired,
  showCategory: PropTypes.bool,
}
